import { render, staticRenderFns } from "./AcceptButton.vue?vue&type=template&id=56bb4560&"
import script from "./AcceptButton.vue?vue&type=script&lang=js&"
export * from "./AcceptButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports